





























import { Component, Vue } from "vue-property-decorator";

@Component({
    filters: {
        maxCharacter(value: string) {
            return value.slice(0, 80);
        }
    },
    components: {}
})
export default class PosterCard extends Vue {
    get fallBackImage() {
        if (
            this.$store.getters.getPageOptions("sessions").posterFallBackImage
        ) {
            return `${process.env.BASE_URL}bg/${
                this.$store.getters.getPageOptions("sessions")
                    .posterFallBackImage
            }`;
        }
        return "";
    }
}
